import BasePostGrid from "@PegasusCore/pegasus-one-post-grid/src/script";

class PostGrid extends BasePostGrid {
    preview = false;
    searchTerm = '';
    isSearching = false;

    _search = '';

    get search() {
        return this._search;
    }

    set search(value) {
        this._search = value;

        const searchFilterKey = this.getPrefixedFilter('search', 'search');

        if (value.trim().length > 0) {
            // Keep search filter if there is still text
            this.currentFilters[searchFilterKey] = value.trim();
        } else {
            // Only remove search filter if it's truly empty
            delete this.currentFilters[searchFilterKey];
        }

        this.fetchContent(null, true);
    }

    constructor(preview) {
        super();
        this.preview = preview;
    }

    init() {
        super.init();

        this.ignoreFilters();

        if (this.preview) {
            return;
        }
        if (Object.values(this.currentFilters).length) {
            // this.getAllPostGrids();
            this.getAllPostGrids().forEach((container) => {
                container.remove();
            });
        }

        const flag = this.$root.querySelector('[data-allow-single-filter]');
        this.allowSingleFilter = flag?.dataset.allowSingleFilter === "true";

        // Set up global function for removing filter terms
        window.removeFilterTerm = (term, filterKey) => {
            this.removeSingleFilter(term, filterKey);
        };

        // Restore scroll position after page load (if available)
        const savedScrollY = sessionStorage.getItem('postGridScrollY');
        if (savedScrollY !== null) {
            sessionStorage.removeItem('postGridScrollY');
            window.scrollTo({ top: parseInt(savedScrollY), behavior: 'auto' });
        }
    }

    ignoreFilters() {
        Object.keys(this.currentFilters).forEach((key) => {
            if (!key.startsWith("filter-")) {
                delete this.currentFilters[key];
            }
        });
    }
  
    clearFilters() {
        // Save current scroll position before reload
        sessionStorage.setItem('postGridScrollY', window.scrollY);

        // Clear filters and reload page
        this.currentFilters = {};
        window.location.href = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
    }

    clearFilters() {
        // Save current scroll position before reload
        sessionStorage.setItem('postGridScrollY', window.scrollY);

        // Clear filters and reload page
        this.currentFilters = {};
        window.location.href = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
    }

    fetchContent(href = null, isSearch = false) {
        const postGrid = this.postGrid.querySelector('[data-pegasus-filterable]');
        const elements = ['data-pegasus-filterable="' + postGrid.dataset.pegasusFilterable + '"'];
        
        let currentUrl = '';

        // Always build a URL for AJAX, even if no filters exist
        if (href) {
            currentUrl = href;
        } else {
            currentUrl = this.buildUrl();
        }

        if (!this.isLoading && !this.isSearching) {
            this.isLoading = true;

            if(isSearch) {
                this.isSearching = true;
            }

            pegasus.ajaxContent(currentUrl, elements, {}, () => {
                this.isLoading = false;

                history.pushState(
                    Object.keys(this.currentFilters).length ? JSON.stringify(this.currentFilters) : '',
                    '',
                    currentUrl
                );

                this.isSearching = false;

                // if(!isSearch) {
                //     history.pushState(JSON.stringify(this.currentFilters), '', currentUrl);
                // }

                if (typeof window.allModals !== "undefined") {
                    window.allModals().init();
                }

                if (this.preview) return;

                this.reinitHubspot();

                this.getAllPostGrids().forEach((container) => {
                    container.remove();
                });

                const postGrid = document.querySelector('.Post__Grid');
                if (postGrid) {
                    const filterBar = postGrid.querySelector('.Post__Grid-filters');
                    if (filterBar) {
                        const rect = filterBar.getBoundingClientRect();
                        const currentScroll = window.pageYOffset;
                        const targetScroll = currentScroll + rect.top - 81;

                        window.scrollTo({
                            top: targetScroll,
                            behavior: 'smooth'
                        });
                    }
                }
                if(isSearch) {
                    window.dispatchEvent(new CustomEvent('closeSearchModal'));
                }
            });
        }
    }

    fetchPage(href = null) {
        const postGrid = this.$root.querySelector('[data-pegasus-filterable]');
        const elements = ['data-pegasus-filterable="' + postGrid.dataset.pegasusFilterable + '"'];

        if (!this.isLoading) {
            this.isLoading = true;

            pegasus.ajaxContent(href, elements, {}, () => {
                this.isLoading = false;
                history.pushState('', '', href);

                if (typeof window.allModals !== "undefined") {
                    window.allModals().init();
                }

                                  // Scroll to the filter bar instead of the grid
                 const postGrid = document.querySelector('.Post__Grid');
                 if (postGrid) {
                     const filterBar = postGrid.querySelector('.Post__Grid-filters');
                     if (filterBar) {
                         const rect = filterBar.getBoundingClientRect();
                         const currentScroll = window.pageYOffset;
                         const targetScroll = currentScroll + rect.top - 81;
                         
                         window.scrollTo({
                             top: targetScroll,
                             behavior: 'smooth'
                         });
                     }
                 }

                this.reinitHubspot();

            });
        }
    }

    reinitHubspot() {
        const hubspotForm = document.querySelectorAll('#content .hbspt-form');
        hubspotForm.forEach((form) => {
            const script = form.parentElement.querySelector('script');

            if (script) {
                
                const scriptContent = script.textContent;

                const formId = this.getSubstringBetween(
                    scriptContent,
                    'formId: "',
                    '"'
                );
                const portalId = this.getSubstringBetween(
                    scriptContent,
                    "portalId: ",
                    ","
                );
                const target = this.getSubstringBetween(
                    scriptContent,
                    'target: "',
                    '"'
                );
                setTimeout(() => {
                    hbspt.forms.create({
                        portalId,
                        formId,
                        target,
                    });
                }, 200);
            
            }
        });
    }

    getSubstringBetween(str, startDelimiter, endDelimiter) {
        // Find the start position of the substring
        const startIndex = str.indexOf(startDelimiter);
        if (startIndex === -1) {
            // If the start delimiter is not found, return an empty string or handle error
            return "";
        }

        // Find the end position of the substring
        const endIndex = str.indexOf(
            endDelimiter,
            startIndex + startDelimiter.length
        );
        if (endIndex === -1) {
            // If the end delimiter is not found, return an empty string or handle error
            return "";
        }

        // Extract the substring between the start and end delimiters
        const substring = str.substring(
            startIndex + startDelimiter.length,
            endIndex
        );

        return substring;
    }

    getAllPostGrids() {
        const postGrids = document.querySelectorAll(
            "[data-pegasus-filterable]"
        );

        let postGridContainers = [];

        postGrids.forEach((postGrid) => {
            
            const postGridContainer = postGrid.closest(".Post__Grid");

            if (
                postGridContainer &&
                postGridContainer.classList.contains("has-filters")
            ) {
                return;
            }
            const container = postGrid.closest(".Pegasus__Container");
            console.log(container);
            if (!container) {
                return;
            }

            postGridContainers.push(container);
        });
        return postGridContainers;
    }

    getSelectedFilterText(filter) {
        const filterResults = this.currentFilters[`filter-t-${filter}`];
        let filtersArray = [];
        if (filterResults) {
            filtersArray = filterResults.split(",");
        }

        const escapeHtml = (unsafe) => {
            return unsafe
                .replaceAll("&", "&amp;")
                .replaceAll("<", "&lt;")
                .replaceAll(">", "&gt;")
                .replaceAll('"', "&quot;")
                .replaceAll("'", "&#039;");
        };

        if (filtersArray.length === 1) {
            let sector = filtersArray[0];
            sector = escapeHtml(sector);
            const text = this.$root.querySelector(`#${sector}`).textContent;
            return text;
        }

        return "Multiple";
    }

    /**
     * buildUrl
     * 
     * Description: Build the URL to request from based on the current filters.
     * 
     * @return void
     */
    buildUrl() {
        // Set the URL to the current page (without query parameters or pagination)
        let url = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
        url = url.replace(/\/page\/\d+/g, '');

        const filterEntries = Object.entries(this.currentFilters);

        // If no filters, return clean URL
        if (filterEntries.length === 0) {
            return url;
        }

        const params = new URLSearchParams();

        for (const [key, value] of filterEntries) {
            if (value && value.trim() !== '') { // <-- skip empty values
                params.set(key, value);
            }
        }

        const paramString = params.toString();
        return paramString ? `${url}?${paramString}` : url;
    }

    /**
     * toggleFilters
     * 
     * Description: Either add or remove the filter term from 
     * it's taxonomy.
     * 
     * @param {string} term
     * @param {string} filterName
     * @param {string} type
     * @return void
     */
    toggleFilters(term = '', filterName = '', type = 'taxonomy') {
        const filter = this.getPrefixedFilter(filterName, type);
    
        // If this is the first filter to be added, just add it.
        if (typeof this.currentFilters[filter] === "undefined") {
            // If only one filter should be allowed, clear others first
            if (this.allowSingleFilter) {
                Object.keys(this.currentFilters).forEach((key) => {
                    if (key !== filter) {
                        delete this.currentFilters[key];
                    }
                });
            }
    
            this.currentFilters[filter] = term;
    
            // Refresh the post grid content
            this.fetchContent();
            return;
        }
    
        // If we have filters for the current filter, check if the term is already in the list.
        if (this.currentFilters[filter].length) {
            if (this.currentFilters[filter].includes(term)) {
                this.currentFilters[filter] = this.removeFilter(filter, term);
                if (!this.currentFilters[filter].length) {
                    delete this.currentFilters[filter];
                }
            } else {
                if (this.allowSingleFilter) {
                    Object.keys(this.currentFilters).forEach((key) => {
                        if (key !== filter) {
                            delete this.currentFilters[key];
                        }
                    });
                }

                if (filter.startsWith('filter-s-')) {
                    this.currentFilters[filter] = term;
                    this.searchTerm = term;
                } else {
                    this.currentFilters[filter] += ',' + term;
                }
            }

        } else {
            // If there isn't a filter for this filter, add it and then add the term to it.
            this.currentFilters[filter] = term;
        }
    
        // Refresh the post grid content
        this.fetchContent();
    }

     /**
     * loadMore
     * 
     * Description: Loads the next page of posts below the current set of posts.
     * @return void
     */   
     loadMore(){

        // Get the post grid container and the data selector for the post grid.
        const postGrid = this.$root.querySelector('[data-pegasus-filterable]');
        const dataSelector = '[data-pegasus-filterable="'+postGrid.dataset.pegasusFilterable+'"]';
    
        // Get the url for the next page of posts. This is taken from the href of the load more button.
        const href = this.$el.getAttribute("href");

        // Get the container and elements to be loaded from the next page.
        const container = [dataSelector];
        const elements = ['[data-pegasus-single-card]', '.Post__Grid-next-page'];

        // Only allow the load more button to be clicked whilst we're not waiting for a response.
        if(!this.isLoading){
            this.isLoading = true;

            // Run the loadMoreContent function from pegasus.
            pegasus.loadMoreContent(href, container, elements, {}, () => {
                this.isLoading = false;

                // Remove the load more button from the original page, 
                // keeping only the one that comes back from the request.
                this.$el.parentElement.remove();

                if (typeof window.allModals !== "undefined") {
                    window.allModals().init();
                }
            });
        }

    }

    /**
     * removeFilter
     * 
     * Description: Removes a given term from it's taxonomy filter.
     * 
     * @param {string} filter
     * @param {string} value
     * @return string
     */
    removeFilter(filter, value){
        // Get the filter values from the currentFilters array
        const filterValue = this.currentFilters[filter];

        // Turn the filter values into an array
        const filterValueArray = filterValue.split(',');

        // Loop through the array and remove the given value
        for(let i = 0; i < filterValueArray.length; i++){
            if (filterValueArray[i] === value) { 
                filterValueArray.splice(i, 1); 
            }   
        }

        // Return the array as a string
        return filterValueArray.toString();
    }

    /**
     * filterIsActive
     * 
     * Description: Checks if a given filter is currently selected.
     * 
     * @param {string} term
     * @param {string} filter
     * @param {string} type
     * @return {boolean}
     */
    filterIsActive(term, filter, type = 'taxonomy'){
        const filterName = this.getPrefixedFilter(filter, type);
        if(typeof this.currentFilters[filterName] !== "undefined"){
            return this.currentFilters[filterName].includes(term);
        }
        return false;
    }

    /**
     * getPrefixedFilter
     * @param {string} filter
     * @param {string} type
     * @return {string}
     */
    getPrefixedFilter(filter, type = 'taxonomy'){
        return `filter-${type === 'taxonomy' ? 't' : type === 'search' ? 's' : 'c'}-${filter}`;
    }

    /**
     * getTermName
     * 
     * Description: Gets the display name of a term from the DOM
     * 
     * @param {string} term
     * @param {string} filterKey
     * @return {string}
     */
    getTermName(term, filterKey) {
        // Try to find the term element in the DOM
        const termElement = this.$root.querySelector(`#${term}`);
        if (termElement) {
            return termElement.textContent.trim();
        }

        // If not found, return the term slug as fallback
        return term;
    }

    /**
     * removeSingleFilter
     * 
     * Description: Removes a single term from a specific filter
     * 
     * @param {string} term
     * @param {string} filterKey
     * @return void
     */
    removeSingleFilter(term, filterKey) {
        // Extract the filter name and type from the filter key
        const parts = filterKey.split('-');
        if (parts.length >= 3) {
            const type = parts[1] === 't' ? 'taxonomy' : parts[1] === 's' ? 'search' : 'custom';
            const filterName = parts.slice(2).join('-');

            // Use the existing toggleFilters method to remove the term
            this.toggleFilters(term, filterName, type);
        }
    }

    /**
     * renderActiveFilters
     * 
     * Description: Renders the HTML for active filter tags
     * 
     * @return {string}
     */
    renderActiveFilters() {
        let html = '';

        for (const [filterKey, filterValue] of Object.entries(this.currentFilters)) {
            if (filterValue && filterValue.length) {
                const terms = filterValue.split(',');
                for (const term of terms) {
                    const termName = this.getTermName(term, filterKey);
                    html += `
                        <div class="flex items-center gap-2 bg-primary-10 text-primary px-3 py-2 rounded-full text-sm">
                            <span>${termName}</span>
                            <button onclick="window.removeFilterTerm('${term}', '${filterKey}')" class="ml-1 hover:bg-primary hover:text-white rounded-full p-1 transition-colors">
                                <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
                                </svg>
                            </button>
                        </div>
                    `;
                }
            }
        }

        return html;
    }

    clearSearchFilter() {
        const searchFilterKey = this.getPrefixedFilter('search', 'search'); // e.g. filter-s-search

        // Remove the search filter key completely from currentFilters
        if (this.currentFilters[searchFilterKey]) {
            delete this.currentFilters[searchFilterKey];
        }

        // Clear the internal search term state
        this.searchTerm = '';
        this.search = '';

        // Clear the actual input field in the DOM (if present)
        const searchInput = this.$root.querySelector('input[type="search"], input[data-search-input]');
        if (searchInput) {
            searchInput.value = '';
        }

        // Refresh the content and URL
        this.fetchContent();
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("postGrid", (preview) => new PostGrid(preview));
});
